import Model, { attr } from '@ember-data/model';

export type Status = 'pending' | 'in_progress' | 'complete' | 'incomplete';

type RequiredQuestionnaireData = {
  id: string;
  position: number;
  title: string;
};

type RawCompletionSummaryItem = {
  'completed-at': Date;
  'questionnaire-id': string;
  score: number;
  status: string;
};

type CompletionSummaryItem = {
  completedAt: Date;
  questionnaireId: string;
  score: number;
  status: string;
};

function deserializeCompletionSummary(raw: RawCompletionSummaryItem): CompletionSummaryItem {
  return {
    completedAt: raw['completed-at'],
    questionnaireId: raw['questionnaire-id'],
    score: raw['score'],
    status: raw['status'],
  };
}

class QuestionnaireResponseStatus extends Model {
  @attr('string') declare overallStatus: Status;
  @attr('number') declare totalCompleted: number;
  @attr('number') declare totalPassed: number;
  @attr('number') declare totalRequired: number;

  @attr('array') declare requiredQuestionnaires: RequiredQuestionnaireData[];
  @attr('array', { deserializeItem: deserializeCompletionSummary }) declare completionSummary: CompletionSummaryItem[];

  @attr('date') declare initiatedAt: Date;
  @attr('date') declare finalizedAt: Date | null;
}

export default QuestionnaireResponseStatus;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'questionnaire-response-status': QuestionnaireResponseStatus;
  }
}
